import { render, staticRenderFns } from "./ShopAllCategories.vue?vue&type=template&id=2cc381f4&scoped=true&"
import script from "./ShopAllCategories.vue?vue&type=script&lang=ts&"
export * from "./ShopAllCategories.vue?vue&type=script&lang=ts&"
import style0 from "./ShopAllCategories.vue?vue&type=style&index=0&id=2cc381f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc381f4",
  null
  
)

export default component.exports